document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-mz-open-menu]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.mzOpenMenu);
    if (dialog && !dialog.open) dialog.showModal();
  }
  const closer = event.target.closest('[data-mz-close-menu]');
  if (closer) closer.closest('dialog').close();
  if (event.target.matches('.mz-mobile-dialog')) event.target.close();
  if (!event.target.closest('.mz-shop-nav--desktop')) {
    document.querySelectorAll('.mz-shop-nav--desktop details[open]').forEach(item => item.removeAttribute('open'));
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.mz-shop-nav--desktop details[open]').forEach(item => {
      item.removeAttribute('open');
      item.querySelector('summary').focus();
    });
  }
});
document.addEventListener('toggle', (event) => {
  if (event.target.matches('.mz-shop-nav--desktop .mz-nav-group[open]')) {
    event.target.parentElement.querySelectorAll('details[open]').forEach(item => {
      if (item !== event.target) item.removeAttribute('open');
    });
  }
}, true);
